import { MatterPackageHistoryEntry } from '@models/matter-package';

export class Get {
	static readonly type = '[matter-packages-history] get';
	constructor(public payload: { packageId: string }) {}
}

export class Create {
	static readonly type = '[matter-packages-history] create';
	constructor(
		public payload: { packageId: string; entry: MatterPackageHistoryEntry },
	) {}
}

export class SetCurrentPackageId {
	static readonly type = '[matter-packages-history] set current package id';
	constructor(public payload: { currentPackageId: string }) {}
}

export class CreateBatch {
	static readonly type = '[matter-packages-history] create batch';
	constructor(
		public payload: { packageId: string; entries: MatterPackageHistoryEntry[] },
	) {}
}
